import React from 'react';
import PropTypes from 'prop-types';

import 'sass/ProfileAvatar.scss';

export default function ProfileAvatar({user, showOnline = true, big = false}) {
    return (
        <div className={'profile-avatar' + (big ? ' big' : '')}>
            {user ? <img src={user.avatar_url} alt={user.nick}/> : <span className="avatar-stub"/>}
            {(user && showOnline) ? <div className={'status' + (user.online ? ' active' : '')}/> : null}
        </div>
    )
}

ProfileAvatar.propTypes = {
    user: PropTypes.object.isRequired,
    showOnline: PropTypes.bool,
    big: PropTypes.bool
};


// WEBPACK FOOTER //
// ./src/components/ProfileAvatar.js